export const clientSideOnly = <T,>(
	x: Promise<{ default: React.ComponentType<T> }>,
): Promise<{ default: React.ComponentType<T> }> => x;
